import React, { useEffect } from 'react';
import AboutBreadcrumbs from '../components/AboutBreadcrumbs';
import AboutCompanyProfile from '../components/AboutCompanyProfile';
import AboutTeam from '../components/AboutTeam';
import ContactCTA from '../components/ContactCTA';
import LatestArticles from '../components/LatestArticles';

const About = () => {
  useEffect(() => {
    if (window.WOW) new window.WOW().init();
  }, []);

  return (
    <main className="about-page">
      <AboutBreadcrumbs />
      <AboutCompanyProfile />
      <AboutTeam />
      <ContactCTA />
      <LatestArticles />
    </main>
  );
};

export default About;
